export enum CustomerRepresentativeOrderTabsEnum {
  'awaiting' = 'awaiting',
  'active' = 'active',
  'unconfirmed' = 'unconfirmed',
  'blocked' = 'blocked',
  'canceled' = 'canceled',
  'paid' = 'paid',
}

export const customerRepresentativeOrderTypes = Object.values(CustomerRepresentativeOrderTabsEnum);
